import React from 'react';
import { PlatformWidget } from '@/lib/module-federation';
import { FallbackPage404 } from './fallback';
import { GraphFallbackPage404 } from './graph-fallback';
import { usePortalSettingsSelector } from '@/src/domains/widgets/selectors';

const TITLE = 'We could not find this dashboard';

const dashboard404Fallback = {
  default: () => <FallbackPage404 title={TITLE} />,
  failed: () => <FallbackPage404 title={TITLE} />,
  isLoading: () => null
};

const graphDashboard404Fallback = {
  default: () => <GraphFallbackPage404 title={TITLE} />,
  failed: () => <GraphFallbackPage404 title={TITLE} />,
  isLoading: () => null
};

export const Dashboard404 = () => {
  const portalSettings = usePortalSettingsSelector();

  return (
    <PlatformWidget
      domain="errors"
      placement="dashboard"
      fallback={portalSettings?.navgraph ? graphDashboard404Fallback : dashboard404Fallback}
    />
  );
};
